











































































































































































































/* eslint-disable @typescript-eslint/camelcase */
import { Vue, Component, Watch, Prop } from 'vue-property-decorator'
import { User } from '@/types/Users'
import { Job } from '@/types/Jobs';
import { exists, phoneRulesOptional, emailRulesOptional } from '@/util/inputValidation'
import RichtextField from '@/components/inputs/RichtextField.vue'
import PhoneInput from '@/components/inputs/PhoneInput.vue'
import GMap from '@/components/GMap.vue'
import { loadManagers } from '@/services/users'
import { createJob, updateJob } from '@/services/jobs'
import { hashColor } from '@/util/helpers'

function emptyJob() {
  return {
    color: hashColor(Date.now()),
    address: null,
    radius: 100,
    notes: '',
    restrict_by_code: true,
    restrict_by_location: true,
    restrict_by_time: true,
    restrict_by_time_window: 0,
  } // TODO: add type
}

@Component({
  components: {
    RichtextField,
    PhoneInput,
    GMap,
  }
})
export default class EditJobDialog extends Vue {

  @Prop({ type: Number }) readonly jobId?: number
  @Prop({ default: false }) readonly opened!: boolean

  editedJob: any = emptyJob()
  isValid = false
  loading = false
  place: any

  rules = {
    name: [exists("Job name required")],
    address: [exists("Address required")],
    consultantPhone: phoneRulesOptional,
    consultantEmail: emailRulesOptional,
    restrictByTimeWindow: [
      exists("Time window required"),
      (value: string) => !isNaN(parseInt(value)) || 'Time window must be a number',
      (value: string) => parseInt(value) >= 0 || 'Time window is invalid',
    ],
  }

  async mounted() {
    await loadManagers(this.$store)
  }

  @Watch('opened')
  onOpened(newVal: boolean) {
    if (newVal) {
      if (this.jobId) {
        this.editedJob = this.$store.getters.job(this.jobId)
      }
      else {
        this.resetForm()
        this.editedJob = emptyJob()
      }
    }
  }

  resetForm() {
    (this.$refs.form as HTMLFormElement)?.reset();
    setTimeout(() => {
      (this.$refs.container as any).$el.parentElement.scrollTop = 0;
    }, 1)
  }

  get showMap() {
    return !!this.editedJob?.address
  }

  get managers(): User[] {
    return this.$store.state.users.managers
  }

  updateJobLocation({ job, index, position }: {
    job: Job
    index: number
    position: { latitude: number; longitude: number }
  }) {
    this.editedJob.latitude = position.latitude
    this.editedJob.longitude = position.longitude
  }

  closeDialog() {
    this.$emit("update:opened", false)
  }

  setPlace(address: any, place: string, id: string) {
    if (this.editedJob) {
      this.editedJob.address = address.name
      this.editedJob.city = address.locality
      this.editedJob.state = address.administrative_area_level_1
      this.editedJob.zip_code = address.postal_code
      this.editedJob.country = address.country
      this.editedJob.latitude = address.latitude
      this.editedJob.longitude = address.longitude
    }
    this.place = place
  }
  async updateJob() {
    this.loading = true
    try {
      if (this.jobId)
        await updateJob(this.$store, this.editedJob)
      else
        await createJob(this.$store, this.editedJob)

      this.closeDialog()
    }
    finally {
      this.loading = false
    }
  }
}
